import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client";

const getSmsTemplates = (clinicid) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/sms-templates`);
};
const getSmsTemplateById = (clinicid, templateId) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/sms-templates/${templateId}`);
};
const updateSmsTemplate = (clinicid, templateId, data) => {
    return axios.put(`${API_URL}/clinics/${clinicid}/sms-templates/${templateId}`, data);
};

const getEmailTemplates = ({clinicid}) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/email-templates`);
};
const getEmailTemplateById = ({clinicid, templateId}) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/email-templates/${templateId}`);
};
const updateEmailTemplate = ({clinicid, templateId, data}) => {
    return axios.put(`${API_URL}/clinics/${clinicid}/email-templates/${templateId}`, data);
};


const getCallTemplates = (clinicid) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/call-templates`);
};
const getCallTemplateById = (clinicid, templateId) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/call-templates/${templateId}`);
};
const getCallAudioPlay = ({clinicid, templateId}) => {
    return axios.get(`${API_URL}/clinics/${clinicid}/call-templates/${templateId}/audio`);
};
const templatesService = {
    getSmsTemplates,
    getSmsTemplateById,
    getEmailTemplates,
    getEmailTemplateById,
    getCallTemplates,
    getCallAudioPlay,
    getCallTemplateById,
    updateSmsTemplate,
    updateEmailTemplate 
};


export default templatesService;
